import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "root",
  tabindex: "-1",
  class: "trailer-modal",
  role: "dialog",
  "aria-labelledby": "aria-modalLabel",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "trailer-modal__content" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "trailer-modal__backdrop",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("video", {
        src: _ctx.videoSrc,
        type: "video/mp4",
        controls: "",
        autoplay: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
        class: "close"
      }, [
        _createVNode(_component_Icon, {
          name: "close",
          size: "lg"
        })
      ])
    ])
  ], 512))
}